import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  FormControl,
  Button,
  Grid,
  InputLabel,
  Select,
  Typography,
  MenuItem
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Header from "../../components/Header";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetCategoryQuery } from "../../state/api";
import { getInterestAction } from "../../redux/actions/interestAction";
import LoadingIndicator from "../../components/loadingIndicator";
import { updateInterestAction } from "../../redux/actions/interestAction";

const EditInterest = () => {
  const location = useLocation();
  const { pathname } = location;
  const interestId = pathname.split("/").pop();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState({});
  const navigate = useNavigate();

  const initialFormState = {
    title: "",
    isActive: "",
    categoryId: ""
  };

  const [formData, setFormData] = useState(initialFormState);

  useEffect(
    () => {
      const fetchInterestDetails = async () => {
        try {
          const response = await dispatch(getInterestAction(interestId));
          if (response && response.success) {
            const interestDetails = response.response;
            setFormData(interestDetails);
          } else {
            console.log("Failed to fetch interest details");
            toast.error("Failed to fetch interest details");
          }
        } catch (error) {
          console.log("Error fetching interest details", error);
          toast.error("Error fetching interest details");
        }
      };

      fetchInterestDetails();
    },
    [interestId, dispatch]
  );

  const { data: categoryIds, error } = useGetCategoryQuery();

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = async e => {
    const fieldName = e.target.name;
    try {
      // await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    console.log("FormData:", formData);
    try {
      // await validationSchema.validate(formData, { abortEarly: false });
      setLoading(true); // Start loading
      const updatedFormData = {
        ...formData
      };

      const response = await dispatch(
        updateInterestAction(interestId, updatedFormData)
      );
      if (response) {
        toast.success("Interest updated successfully");
        navigate("/category");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Failed to update Interest");
      }
    } catch (validationErrors) {
      // Handle validation errors
      const errors = {};
      if (validationErrors.inner) {
        validationErrors.inner.forEach(validationError => {
          errors[validationError.path] = validationError.message;
        });
      }
      setErr(errors);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="2.5rem" mr="2.5rem">
      <Header title="EDIT INTEREST" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          {/* TITLE */}
          <TextField
            label="Title"
            name="title"
            onChange={handleChange}
            onBlur={handleBlur}
            value={formData.title}
            margin="normal"
          />
          {err.title &&
            <Grid item>
              <Typography color="error">
                {err.title}
              </Typography>
            </Grid>}{" "}
          {/* IS ACTIVE */}
          <FormControl fullWidth margin="normal">
            <InputLabel>Is Active</InputLabel>
            <Select
              name="isActive"
              value={formData.isActive}
              onBlur={handleBlur}
              onChange={handleChange}
            >
              <MenuItem value="true">True</MenuItem>
              <MenuItem value="false">False</MenuItem>
            </Select>
          </FormControl>
          {err.isActive &&
            <Grid item>
              <Typography color="error">
                {err.isActive}
              </Typography>
            </Grid>}{" "}
          {/* CATEGORY ID */}
          <FormControl fullWidth margin="normal">
            <InputLabel>Category</InputLabel>
            <Select
              name="categoryId"
              value={formData.categoryId}
              onBlur={handleBlur}
              onChange={handleChange}
            >
              {categoryIds &&
                categoryIds.data &&
                categoryIds.data.map(category =>
                  <MenuItem key={category._id} value={category._id}>
                    {category.title}
                  </MenuItem>
                )}
            </Select>
          </FormControl>
        </FormControl>
        {err.categoryId &&
          <Grid item>
            <Typography color="error">
              {err.categoryId}
            </Typography>
          </Grid>}{" "}
        {/* SUBMIT BUTTON */}
        <Grid container justifyContent="center" alignItems="center">
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            color="primary"
            startIcon={<SendIcon />}
          >
            Submit
          </Button>
        </Grid>
      </form>
      {loading && <LoadingIndicator />}
    </Box>
  );
};
export default EditInterest;
